<template>
    <div>
        <div class="listingPageTitle">
            <h1>Feedback Subject Maintenance</h1>
            <ItemModal ref="modal" :itemName="'Feedback Subject'"
                            :formRows="newFormRows"
                            :saveItemFunction="saveRecord"
                            :refreshItemsFunction="loadRecords"></ItemModal>
        
        </div>
        <div class="searchContainer">
            <div class="formRow"><span class="inputTitle">Search Description: </span><input type="text" v-model="searchText" /></div>
            <div class="formRow"><span class="inputTitle">Active Only: </span><input type="checkbox" v-model="onlyShowActive" /></div>
        </div>
        <hr />
        <ListingTable :columns="columns" :filterCriteria="filterCriteria" :actions="actionMappings" 
            :key="componentKey" :intitializationParameters="{ sortBy: 'name'}" />
    </div>
</template>

<script>
import {data} from '../../shared/data';
import ItemModal from '@/components/ItemModal.vue';
import ListingTable from '@/components/shared/ListingTable.vue';

export default {
    name: 'FeedbackSubjectListing',
    components: {ItemModal, ListingTable},
    data: function() {
        return {
            feedbackSubjects: [],
            searchText: "",
            onlyShowActive: true,
            componentKey: 0,
            columns: [ 
                {
                    headerDisplayName: "ID",
                    width: "10%",
                    fieldName: "id"
                },
                {
                    headerDisplayName: "Code",
                    width: "10%",
                    fieldName: "subjectCode",
                    isEditLink: true
                },
                {
                    headerDisplayName: "Description",
                    width: "60%",
                    fieldName: "text"
                },
                {
                    width: "10%",
                    columnType: "buttons",
                    showDeleteFieldName: "isActive",
                    showUndeleteFieldName: "!isActive",
                    showEditFieldName: "isActive",
                    showListingFieldName: null
                }
            ],
            newFormRows: [
                {
                    name: 'Code',
                    propertyName: 'subjectCode',
                    required: true,
                    element: 'input'
                },
                {
                    name: 'Description',
                    propertyName: 'text',
                    required: true,
                    element: 'textarea'
                }
            ],
            actionMappings: {
                onLoadData: this.loadRecords,
                onDelete: this.deleteRecord, 
                onUndelete: this.reactivateRecord,
                onEdit: this.editRecord
            }        }
    },
    computed: {
        filterCriteria () {
            var criteria = [];
            if(this.searchText != "") 
                criteria.push( {
                    dataType: "String",
                    fieldName: "text",
                    value: this.searchText
                });

            if(this.onlyShowActive) {
                criteria.push( {
                    dataType: "Boolean",
                    fieldName: "isActive",
                    value: true
                });

            }
            return criteria;
        }
    },
    mounted() {
        this.loadRecords();
    },
    methods: {
        loadRecords: async function() {
            return await data.getFeedbackSubjects(this.searchText, false);
        },
        saveRecord: async function(saveObject) {
            return await this.save_common(saveObject, true); 
        },
        save_common: async function(saveObject, displaySuccess) {
            var retObject = this.processSaveResult(await data.saveFeedbackSubject(saveObject));

            if(retObject.success) {
                if(displaySuccess)
                    this.componentKey++;

                if(retObject.id)
                    saveObject.id = retObject.id;

                return retObject;
                
            }
            else
                return retObject;
        },
        editRecord: async function(values) {
            var editRecord = await data.getFeedbackSubject(values.id);  
            this.$refs.modal.editRecord(editRecord.id, editRecord);  
        },
        deleteRecord: async function(values) {
            if(confirm('Are you sure you want to delete this feedback subject?')) {
                var status = this.processDeactivateResult(await data.deleteFeedbackSubject(values.id));
                if(status.success) 
                    values.isActive = false;                      
            }
        },
        reactivateRecord: async function(values) {
            values.isActive = true;
            var status = await this.save_common(values, false);
            if(!status.success)
                values.isActive = false;
        },
    }
}
</script>
